import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { WebService}  from '../services/web/web.service';
import { ToastService } from '../services/notification/toast.service';
import {SpinnerService} from '../services/spinner/spinner.service';
import {SecurityService} from "../services/security.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-login-onboard',
    templateUrl: './login-onboard.component.html',
    styleUrls: ['./login-onboard.component.scss'],
    standalone: false
})
export class LoginOnboardComponent {

    exist: boolean = false;
    partner: any;
    config: any;

    buttonText: string = "";

    constructor(private securityService: SecurityService,
                private router: Router,
                private spinner: SpinnerService,
                private webService: WebService,
                private toast: ToastService,
                private translate: TranslateService) {
    }

    ngOnInit(): void {

        this.partner = this.securityService.getTokenPartner();
        this.config = this.securityService.getTokenConfigs();

        if (this.partner != undefined) {
            this.exist = true;
            if (this.config.length == 1) {
                this.buttonText = this.translate.instant('loginOnboard.buttons.continueToPortal');
            } else if (this.config.length > 1) {
                this.buttonText = this.translate.instant('loginOnboard.buttons.viewMyPortals');
            }
        } else {
            this.buttonText = this.translate.instant('loginOnboard.buttons.createFirstSubscription');
        }

    }

    // FUNCION PARA CONTROLAR DEPENDIENDO DEL ESTEP DONDE SE ENCUENTRE EL CLIENTE, LLEVARLO A SU SIGUIENTE STEP
    goStep() {

        if (!this.exist) { // EN CASO DE QUE NO HAYA PARTNER CREAO ENTONCES LO ENVIAMOS AL STEP1 = settings
            this.router.navigateByUrl("/settings");
            return;
        } else {
            this.spinner.open()
            // AQUI EL PARTNER SI EXISTE, POR LO TANTO CONSULTAMOS EN QUE STEP SE ENCUENTRA
            if (this.config.length == 0 || this.config.length == 1) {
                this.webService.get(this.webService.HOST + "/billcentrix/V2/step/partner/" + this.partner).subscribe(response => {
                    // AQUI CONSIDERAMOS LOS DISTINTOS STEPS RESTANTES
                    this.spinner.close();
                    switch (response.result.current_step) {
                        case 2 :
                            this.router.navigateByUrl("/plans"); //step 2
                            break;
                        case 3 :
                            this.router.navigateByUrl("/portal"); //step 3
                            break;
                        default:
                            this.router.navigateByUrl("/personalize");  // CUALQUIERA DISTINTO A LOS ANTERIORES ENTONCES LO ENVIAMOS AL PASO FINAL
                    }

                }, err => {
                    this.spinner.close();
                    this.toast.showError(err);
                });
            } else { // EN CASO QUE TENGA MAS DE 1 PORTAL ENTONCES LO ENVIAMOS A SUS PORTALES
                this.router.navigateByUrl("/my-portals");
            }
        }

    }


}
